const { LEVEL_IDS } = require('common/constants');

export function generateLevelMap(maxLevel) {
  return LEVEL_IDS.slice(0, LEVEL_IDS.indexOf(maxLevel) + 1);
}
